import { FC } from 'react'

import { EuiPage, EuiPageBody, EuiPanel } from '@elastic/eui'

export const Layout: FC = ({ children }) => {
  return (
    <EuiPage className='euiPage--platform'>
      <EuiPageBody>
        <EuiPanel grow={false} style={{ height: '100%' }}>
          <div style={{ padding: '24px', height: '100%' }} className='eui-xScroll'>
            {children}
          </div>
        </EuiPanel>
      </EuiPageBody>
    </EuiPage>
  )
}
